import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateLearningTrackRes;
export const addUpdateLearningTrackTodo = createAsyncThunk('addUpdateLearningTrack', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/add_update_learning_path',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "created_by": user_id.vemp_code,
                "learning_title": data.title,
                "description": data.description,
                "newCourseIds": data.new_course,
                "learning_id": data.track_id,
                "oldCourseIds": data.old_course,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateLearningTrackRes = res.data
    } catch (error) {
        return addUpdateLearningTrackRes = error.response.data
    }
})